export default __webpack_public_path__ + "static/certificate-kids-square-9895dd2ff6f184e84063258398e3bf97.png";